import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';

export default function NoPlans() {
  return (
    <Row>
      <Col md="6">
        <div className="bg-gray-100 rounded p-3">
          <h6>Nothing&apos;s here</h6>

          <p>To see the summary please set up the policy first.</p>

          <div className="mt-2 text-end">
            <a href={routes.managers.policy.index} className="btn btn-primary btn-sm">
              Go to Policy
            </a>
          </div>
        </div>
      </Col>
    </Row>
  );
}
